export default {
  header: {
    addshequn: "フォロー",
    allproduct: "製品一覧",
    onproduct: "プロダクト",
    lineshop: "オンラインショップ",
    heyan: "正規品の検証"
  },
  footer: {
    aboutus: "蝸之殼Snail Shellについて",
    business: "事業提携",
    aftersales: "アフターサービス",
    agreement: "利用規約",
    language: "日本語"
  },
  login: {
    email: "メールアドレス",
    code: "検証番号",
    sendcode: '送信する',
    password: "パスワード",
    newpassword: "新しいパスワード",
    signin: "サインイン",
    signup: '会員登録',
    signout: 'サインアウト',
    reset: "パスワードをリセット",
    gologin: "はじめてのお客様",
    goreset: "パスワードをお忘れですか？",
    gosignin: "アカウントはお持ちですか?",
    change: "アイコン変更",
    save: "保存",
    nickname: "ニックネーム",
    nicknametip: "あなたのニックネームはコレクションカードに表示される。",
    cropper: "画像を切り取る"
  },
  user: {
    collectioncard: "コレクションカード",
    message: "メッセージ",
    edit: "個人情報編集"
  },
  content: {
    nocontent: "ここに何もありません。",
    download: "ダウンロード",
    cancel: "キャンセル",
    wxqun: "Wechat公式チャットグループ",
    followus: "フォロー",
    whoweare: "会社概要",
    whoweare1: "鄭州蜗之殻文化伝媒有限公司は2019年に設立され、オリジナルの組み立て式フィギュアの研究開発と製造に特化した新鋭企業であり、卓越した製品力を武器に、瞬く間に国内フィギュアブランドのトップクラスに躍り出ました。当社のコア研究開発チームは、国内外のトップクラスの模型機関出身者で構成されており、長年の業界経験と数々のヒット商品を生み出した実績を有しています。原画デザイン、3Dモデリング、塗装工程から製品撮影に至るまでの全プロセスを自社で一貫して行う研究開発体制を構築しています。 ",
    whoweare2: "2023年、当社は自社生産拠点と金型工場を建設し、研究開発と生産の深い連携を実現することで、納品効率と品質管理基準を大幅に向上させました。2024年初頭には、業界をリードする5軸CNC彫刻機をいち早く導入し、従来の鋳造鋼プロセスから高精度CNC加工への技術アップグレードを完了させました。これにより、金型の精度と製品のディテール表現力を業界トップレベルに引き上げ、技術的優位性をさらに強固なものにしました。今後も「蜗之壳」は、技術革新を中核的な原動力とし、世界中のフィギュア愛好家のために、芸術的価値と遊び心を兼ね備えた高品質なオリジナル可動フィギュアの制作に尽力してまいります。",
    kaifa_ycjn: "オリジナル製品の開発",
    kaifa_sqcp: "ライセンス製品の開発",
    kaifa_more: "この先…",
    wetodo: "弊社の事業",
    contactus: "お問い合わせ",
    contactus1: "「蝸之殼Snail Shell」はホビー業界の各業種の企業との提携を期待しております！",
    contactus2: "ライセンス製品の開発・クロスフィールドの業務提携・流通販売などにご興味があれば、ぜひご連絡ください。",
    contactusaddress: "河南省鄭州経済技術開発区東航路・静海20街交点中興新営港三期28号28棟5階501室"
  },
  verify: {
    tip: "パッケージ背面のスクラッチ部分を削って、シリアルコードを獲得した上、確認用ウェブページにコードを入力すれば確認できます。",
    verifybtn: "検証",
    where: "検査コードを見つける方法？",
    noinfo: "申し訳ありませんが、該当する商品が見つかりません。",
    firstinfo: "初回認証の結果が以下となります",
    nofirstinfo: "確認済み！",
    nofirsttip: "今回の認証は初回ではございません",
    firsttime: "初回確認の日時：",
    cardstxt: "所有者"
  },
  goods: {
    knowmore: "詳細情報",
    buybtn: "今すぐ購入",
    sellstatus_yushou: '予約',
    sellstatus_xianhuo: '発売済み',
    goodsinfo: '商品情報',
    goodsandaside: '内容物',
    goodsphotos: 'ギャラリー'
  },
  tdk: {
    home: '蝸之殼Snail Shell',
    products: '蝸之殼Snail Shell - 製品一覧',
    peripherals: '蝸之殼Snail Shell - 周辺機器',
    verify: '蝸之殼Snail Shell - 正規品の検証',
    aboutUs: '蝸之殼Snail Shell - コミュニティ',
    afterSales: '蝸之殼Snail Shell - アフターサービス',
    agreement: '蝸之殼Snail Shell - 利用規約',
    userCenter: '蝸之殼Snail Shell',
    userEdit: '蝸之殼Snail Shell - 個人情報編集',
    login: '蝸之殼Snail Shell - サインイン',
    reset: '蝸之殼Snail Shell - パスワードをリセット',
    signUp: '蝸之殼Snail Shell - 会員登録',
    productinfo: '蝸之殼Snail Shell - '
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/app-ja.js